function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
// ----------------------------------------------------------------------------
// Snippet: Card — Badge Icon Resolver
// ----------------------------------------------------------------------------
// Algolia and Rebuy product cards only know the badge icon as a Shopify
// MediaImage GID (e.g. `gid://shopify/MediaImage/123`) — the Algolia index and
// Rebuy payloads never resolve it to a CDN URL, and it isn't exposed as a
// Storefront metafield. This resolves those GIDs to image URLs directly via the
// Storefront API `nodes` query, caches them, and paints them into the card's
// `.card__icon-badge`. Liquid-rendered cards already carry a resolved `src` and
// carry no GID attribute, so they are left untouched.

import { storefrontApi } from 'scripts/helpers/iamota-shopify-storefront';
var ICON_SELECTOR = 'img[data-product-card-icon][data-badge-icon-gid]';
var WRAP_SELECTOR = '[data-product-card-icon-wrap]';
var GID_ATTR = 'data-badge-icon-gid';
var ALT_ATTR = 'data-badge-icon-alt';
var STORAGE_KEY = 'iamotaBadgeIconUrls';
var GID_RE = /^gid:\/\/shopify\/MediaImage\/\d+$/;
var CHUNK = 100;

// gid -> url. '' means "resolved, but no image" (cached so we never refetch).
var urlCache = new Map();
// gid -> in-flight Promise, so overlapping scans don't refetch the same GID.
var pending = new Map();
var storageLoaded = false;
function loadStorage() {
  if (storageLoaded) return;
  storageLoaded = true;
  try {
    var raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return;
    var obj = JSON.parse(raw);
    for (var _ref3 of Object.entries(obj)) {
      var _ref2 = _slicedToArray(_ref3, 2);
      var gid = _ref2[0];
      var url = _ref2[1];
      if (typeof url === 'string' && url) urlCache.set(gid, url);
    }
  } catch (_unused) {
    /* localStorage unavailable / corrupt — ignore */
  }
}
function persistStorage() {
  try {
    var obj = {};
    for (var _ref6 of urlCache) {
      var _ref5 = _slicedToArray(_ref6, 2);
      var gid = _ref5[0];
      var url = _ref5[1];
      if (url) obj[gid] = url;
    }
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(obj));
  } catch (_unused2) {
    /* ignore quota / privacy-mode errors */
  }
}

/**
 * @param {HTMLImageElement} img
 * @param {string} url — resolved URL, or '' to hide the badge
 */
function paintIcon(img, url) {
  var wrap = img.closest(WRAP_SELECTOR);
  if (url) {
    if (img.getAttribute('src') !== url) img.src = url;
    if (!img.alt) {
      var alt = img.getAttribute(ALT_ATTR);
      if (alt) img.alt = alt;
    }
    if (wrap) wrap.hidden = false;
  } else {
    img.removeAttribute('src');
    if (wrap) wrap.hidden = true;
  }
}
function paintCached(root) {
  var scope = root && root.querySelectorAll ? root : document;
  scope.querySelectorAll(ICON_SELECTOR).forEach(img => {
    var gid = img.getAttribute(GID_ATTR);
    if (gid && urlCache.has(gid)) paintIcon(img, urlCache.get(gid));
  });
}

/**
 * Batch-resolve MediaImage GIDs to CDN URLs via the Storefront API.
 * @param {string[]} gids
 * @returns {Promise<Map<string, string>>}
 */
function fetchGids(_x) {
  return _fetchGids.apply(this, arguments);
}
/**
 * Scan the DOM (or a subtree) for unresolved badge-icon GIDs, paint cache hits
 * immediately, and batch-fetch the rest.
 * @param {ParentNode} [root=document]
 */
function _fetchGids() {
  _fetchGids = _asyncToGenerator(function* (gids) {
    var out = new Map();
    var query = "query BadgeIcons($ids: [ID!]!) {\n        nodes(ids: $ids) {\n            ... on MediaImage { id image { url altText } }\n        }\n    }";
    for (var i = 0; i < gids.length; i += CHUNK) {
      var slice = gids.slice(i, i + CHUNK);
      try {
        var resp = yield storefrontApi.request(query, {
          ids: slice
        });
        var nodes = resp && resp.data && resp.data.nodes || [];
        for (var node of nodes) {
          if (node && node.id && node.image && node.image.url) {
            out.set(node.id, String(node.image.url));
          }
        }
      } catch (_unused3) {
        /* leave this slice unresolved; cached as missing below */
      }
      for (var gid of slice) if (!out.has(gid)) out.set(gid, '');
    }
    return out;
  });
  return _fetchGids.apply(this, arguments);
}
function resolveBadgeIcons() {
  var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document;
  loadStorage();
  var scope = root && root.querySelectorAll ? root : document;
  var imgs = [...scope.querySelectorAll(ICON_SELECTOR)];
  if (root instanceof Element && root.matches && root.matches(ICON_SELECTOR)) {
    imgs.push(root);
  }
  if (!imgs.length) return;
  var need = new Set();
  for (var img of imgs) {
    var gid = img.getAttribute(GID_ATTR);
    if (!gid || !GID_RE.test(gid)) {
      paintIcon(img, '');
      continue;
    }
    if (urlCache.has(gid)) {
      paintIcon(img, urlCache.get(gid));
    } else if (!pending.has(gid)) {
      need.add(gid);
    }
  }
  if (!need.size) return;
  var gids = [...need];
  var request = fetchGids(gids).then(map => {
    for (var _gid of gids) {
      urlCache.set(_gid, map.get(_gid) || '');
      pending.delete(_gid);
    }
    persistStorage();
    paintCached(document);
  }).catch(() => {
    for (var _gid2 of gids) pending.delete(_gid2);
  });
  for (var _gid3 of gids) pending.set(_gid3, request);
}
var scheduled = false;
function schedule() {
  if (scheduled) return;
  scheduled = true;
  window.setTimeout(() => {
    scheduled = false;
    resolveBadgeIcons(document);
  }, 50);
}
function init() {
  loadStorage();
  var run = () => resolveBadgeIcons(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, {
      once: true
    });
  } else {
    run();
  }

  // Algolia (instantsearch) and Rebuy (Vue) inject cards after load, so watch
  // for new cards and for GID attribute changes on swatch/variant switches.
  if (typeof MutationObserver === 'function') {
    var observer = new MutationObserver(mutations => {
      for (var m of mutations) {
        if (m.type === 'childList' && m.addedNodes.length) {
          schedule();
          return;
        }
        if (m.type === 'attributes') {
          schedule();
          return;
        }
      }
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: [GID_ATTR]
    });
  }
}
init();
export { resolveBadgeIcons };